webpackJsonp([48],{

/***/ 507:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_app_user_vue__ = __webpack_require__(811);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e38a7e7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_app_user_vue__ = __webpack_require__(985);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_app_user_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e38a7e7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_app_user_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 577:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(578);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(156);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),

/***/ 578:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(579), __esModule: true };

/***/ }),

/***/ 579:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(75);
__webpack_require__(74);
module.exports = __webpack_require__(580);


/***/ }),

/***/ 580:
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(76);
var ITERATOR = __webpack_require__(11)('iterator');
var Iterators = __webpack_require__(22);
module.exports = __webpack_require__(10).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),

/***/ 811:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_apps_app_user_list__ = __webpack_require__(983);





var addApps = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
		var codeApp, roleId, codeCompany, version;
		return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						codeApp = this.codeApp;
						roleId = this.roleId;
						codeCompany = this.$route.params.idCompany;
						version = 1;
						_context.prev = 4;
						_context.next = 7;
						return this.$http.post('permission/' + this.codeUser, { codeApp: codeApp, roleId: roleId, codeCompany: codeCompany });

					case 7:
						this.showNotification('La aplicación se asignó correctamente.', 'success');
						this.codeApp = '';
						this.roleId = 0;
						this.loadData('project/' + this.codeProject + '/user/' + this.codeUser + '/permission', version, codeCompany);
						_context.next = 16;
						break;

					case 13:
						_context.prev = 13;
						_context.t0 = _context['catch'](4);

						if (_context.t0.status === 405) {
							if (_context.t0.data.message === 'El usuario tiene rol asignado para la aplicación.') {
								this.showNotification('El usuario ya tiene un rol asignado para la aplicación seleccionada.', 'error');
							}
						} else {
							this.showError();
						}

					case 16:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this, [[4, 13]]);
	}));

	return function addApps() {
		return _ref.apply(this, arguments);
	};
}();

var loadResources = function () {
	var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
		var request, _ref3, _ref4, apps, roles;

		return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						request = [this.$http.get('project/' + this.codeProject + '/apps'), this.$http.get('company/' + this.idCompany + '/project/' + this.codeProject + '/role')];
						_context2.next = 3;
						return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(request);

					case 3:
						_ref3 = _context2.sent;
						_ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref3, 2);
						apps = _ref4[0];
						roles = _ref4[1];

						this.apps = apps.data.data;
						this.roles = roles.data.data;

					case 9:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this);
	}));

	return function loadResources() {
		return _ref2.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



function created() {
	var version = 1;
	this.loadResources();
	this.params.codeCompany = this.$route.params.idCompany;
	this.loadData('project/' + this.codeProject + '/user/' + this.codeUser + '/permission', version);
}

function deleteRole(value) {
	var _this = this;

	var version = 1;
	var codeCompany = this.$route.params.idCompany;
	this.$http.delete('permission/' + value).then(function () {
		_this.showNotification('Registro eliminado correctamente');
		_this.modalConfirmation.value = false;
		_this.loadResources();
		_this.loadData('project/' + _this.codeProject + '/user/' + _this.codeUser + '/permission', version, codeCompany);
	});
}

function data() {
	return {
		apps: [],
		codeApp: '',
		columns: [{ id: 1, name: 'Aplicación', checked: true, visible: true }, { id: 2, name: 'Rol', checked: true, visible: true }, { id: 3, name: 'Acciones', checked: true, visible: true }],
		roleId: 0,
		roles: []
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'page-app-user',
	components: {
		appUserList: __WEBPACK_IMPORTED_MODULE_4__components_apps_app_user_list__["a" /* default */]
	},
	created: created,
	data: data,
	methods: {
		addApps: addApps,
		loadResources: loadResources,
		deleteRole: deleteRole
	},
	props: {
		codeProject: {
			type: String
		},
		codeUser: {
			type: String
		},
		idCompany: {
			type: String
		}
	}
});

/***/ }),

/***/ 812:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_app_tooltip_button__ = __webpack_require__(150);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



function deleteRole(value) {
	this.$emit('delete-role', value);
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'apps-users-list',
	props: {
		columns: {
			type: Array,
			required: true
		},
		rows: {
			type: Array,
			required: true
		}
	},
	components: {
		appTooltipButton: __WEBPACK_IMPORTED_MODULE_0__components_shared_app_tooltip_button__["a" /* default */]
	},
	methods: {
		deleteRole: deleteRole
	}
});

/***/ }),

/***/ 983:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_user_list_vue__ = __webpack_require__(812);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f06d4a4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_user_list_vue__ = __webpack_require__(984);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_user_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f06d4a4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_user_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 984:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-5"},[_c('app-table',{staticClass:"mt-3 is-not-selectable no-main-list",attrs:{"name":"apps-users","columns":_vm.columns,"rows":_vm.rows,"input-search":false,"main-list":false},scopedSlots:_vm._u([{key:"rows",fn:function(props){return [_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 1)),expression:"showRow(columns, 1)"}],staticClass:"is-not-selectable"},[_vm._v("\n\t\t\t\t"+_vm._s(props.row.app.data.name)+"\n\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 2)),expression:"showRow(columns, 2)"}]},[_vm._v("\n\t\t\t\t"+_vm._s(props.row.role.data.name)+"\n\t\t\t")]),_vm._v(" "),_c('td',[_c('app-tooltip-button',{attrs:{"color":"red","icon":"delete","text":"Eliminar"},on:{"click-icon":function($event){_vm.deleteRole(props.row.id)}}})],1)]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 985:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('header-page',{attrs:{"name":"users-apps","title":_vm.$route.meta.title}}),_vm._v(" "),_c('general-filter',{staticClass:"mt-3"},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":"","justify-start":""}},[_c('v-flex',{attrs:{"xs3":"","pr-3":""}},[_c('v-select',{staticClass:"body-1",attrs:{"background-color":"white","box":"","hide-details":"","item-text":"name","item-value":"codeApp","items":_vm.apps,"label":"Aplicaciones"},model:{value:(_vm.codeApp),callback:function ($$v) {_vm.codeApp=$$v},expression:"codeApp"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":"","pr-3":""}},[_c('v-select',{staticClass:"body-1",attrs:{"background-color":"white","box":"","hide-details":"","item-text":"name","item-value":"id","items":_vm.roles,"label":"Roles"},model:{value:(_vm.roleId),callback:function ($$v) {_vm.roleId=$$v},expression:"roleId"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-btn',{staticClass:"btn-action caption",attrs:{"color":"green"},on:{"click":_vm.addApps}},[_c('v-icon',[_vm._v("add")]),_vm._v("\n\t\t\t\t\tAgregar\n\t\t\t\t")],1)],1)],1)],1),_vm._v(" "),_c('app-user-list',{attrs:{"columns":_vm.columns,"rows":_vm.table.rows},on:{"delete-role":_vm.deleteRole}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/48.5583c8f8416fd88bccd0.js